import { useStore } from 'hooks/useStore';
import { Room } from 'Interfaces/ReferenceInterfaces/RoomInterface';
import { useEffect, useRef, useState } from 'react';
import { useInterval } from 'hooks/usePolling';
import { getJitteredInterval } from 'utils/pollingUtility';
import {toast} from 'react-toastify';

interface FormData {
  room_short: string;
  room_long: string;
}

export const useRoomsTable = (pageSize: number = 100) => {
  const { roomStore } = useStore();

  const [selectedRow, setSelectedRow] = useState<Room | null>(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemMenu = useRef<any>(null);
  const environment = import.meta.env.VITE_ENVIRONMENT;
  const POLLING_INTERVAL = getJitteredInterval();

  useEffect(() => {
    roomStore.fetchRooms(currentPage, pageSize);
  }, [currentPage, pageSize]);

  // Set up polling for data updates
  useInterval(async () => {
    try {
      await roomStore.pollRooms(currentPage, pageSize);
    } catch (error) {
      // Don't break the polling cycle on error
      if(environment === 'development'){
        console.error('Error during polling:', error);
      }
      toast.error('Error during polling for Rooms data!');
    }
  }, POLLING_INTERVAL);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleDeleteRow = () => {
    if (selectedRow) {
      roomStore.deleteRoom(selectedRow.id);
      setSelectedRow(null);
      setShowDeleteModal(false);
    }
  };

  const prepareFormData = (row: Room): FormData => {
    return {
      room_short: row.room_short || '',
      room_long: row.room_long || ''
    };
  };

  return {
    roomData: roomStore.rooms,
    isLoading: roomStore.isLoading,
    pagination: roomStore.pagination,
    itemMenu,
    selectedRow,
    showAddModal,
    showDeleteModal,
    setSelectedRow,
    setShowAddModal,
    setShowDeleteModal,
    handleDeleteRow,
    handlePageChange,
    prepareFormData
  };
};
